import { render, staticRenderFns } from "./TestimonialAd.vue?vue&type=template&id=5d5ea118&scoped=true"
import script from "./TestimonialAd.vue?vue&type=script&lang=js"
export * from "./TestimonialAd.vue?vue&type=script&lang=js"
import style0 from "./TestimonialAd.vue?vue&type=style&index=0&id=5d5ea118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5ea118",
  null
  
)

export default component.exports